<template>
  <div>
    <Header :active="active" />
    <img :src="top_slogan" alt="" class="banner-img">
    <div class="w1300">
      <div class="content-nav">
        <span @click="goIndex()">首页</span>> <span>家政服务</span>
      </div>
      <div class="box">
        <!-- <LeftTab :tabindex="active"/> -->
        <div class="list">
            <ul>
                <li v-for="(item,index) in articleList" :key="index" @click="goInfo(item.id,item.url)">
                    <div class="li-left">{{item.title}}</div>
                    <div class="li-right">{{item.time}}
                        <img src="../assets/images/19.png" alt="">
                    </div>
                </li>
            </ul>
            <el-pagination
            layout="prev, pager, next"
            :total="total"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            style="float: right"
            v-if="total > 10"
          >
          </el-pagination>
        </div>
      </div>
      
    </div>
    <Foot />
  </div>
</template>
<script>
import Header from "../components/header.vue";
import Foot from "../components/foot.vue";
// import LeftTab from "../components/leftTab.vue";
export default {
  components: {
    Header,
    Foot,
    // LeftTab,
  },
  data() {
    return {
      active: 6,
      articleList:[],
      total: "",
      currentPage:1,
      pageSize: 10,
      top_slogan:this.$imgUrl + localStorage.getItem('top_slogan')
    };
  },
  mounted(){
    let id = this.$route.params.id;
    this.list(id)
  },
  methods:{
    goInfo(id,url){
      if(url !== null && url !== undefined && url !== ""){
        window.open(url);
      }else{
        this.$router.push('/fuwuinfo/'+id)
      }
    },
    async list(id){
      let data ={
        cateId:id,
        pageNum:this.currentPage,
        pageSize:this.pageSize
      }
      let res = await this.$get('/web/news/list',data)
      if(res.code == 200){
        this.articleList = res.rows
        this.total = res.total;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.list(this.children_id)
    },   
    goIndex(){this.$router.push('/')}
  }
  
};
</script>
<style scoped>
  .content-nav{border-bottom: solid 1px #bb030d;padding: 15px 0;font-size: 15px;margin-top: 15px;margin-bottom: 40px;}
  .content-nav span{margin-right: 10px;margin-left: 10px;color: #727272;}
  .banner-img{width: 1300px;margin: 0 auto;margin-top: 20px;display: block;}
  .box{display: flex;}
  .list{width: 100%;}
  .list ul li{display: flex;border-bottom: solid 1px #efefef;padding-bottom: 25px;margin-bottom: 35px;}
  .list ul li:hover{cursor: pointer;}
  .li-right{display: flex;font-size: 15px;color: #696969;align-items: center;}
  .li-left{ flex: 1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 60px;}
  .li-right img{width: 25px;height: 25px;margin-left: 10px;}
  .content-nav span:hover{cursor: pointer;}
</style>